// components/agent/employees/AgentTableEmployees.jsx
import moment from "moment"

const AgentTableEmployees = ({agents}) => {

    return (
        <div className=" p-0 md:p-5">
            <div className="overflow-x-auto rounded-lg border border-gray-200">
                <table className="w-full min-w-full table-auto">
                    <thead>
                        <tr className="bg-[#005B96] text-left text-white">
                            <th className="whitespace-nowrap px-7 py-4 font-normal">Name</th>
                            <th className="whitespace-nowrap px-7 py-4 font-normal">Email</th>
                            <th className="whitespace-nowrap px-7 py-4 font-normal">Team</th>
                            <th className="whitespace-nowrap px-7 py-4 font-normal">Location</th>
                            <th className="whitespace-nowrap px-7 py-4 font-normal">Designation</th>
                            <th className="whitespace-nowrap px-7 py-4 font-normal">Join date</th>
                            <th className="whitespace-nowrap px-7 py-4 font-normal">Active</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {agents.map((agent, index) => (
                            <tr
                                key={index}
                                className={index % 2 === 0 ? 'bg-white' : 'bg-slate-50'}
                            >
                                <td className="px-7 py-4">{agent.firstName} {agent.lastName}</td>
                                <td className="px-7 py-4">{agent.email || ""}</td>
                                <td className="px-7 py-4">{agent.team || ""}</td>
                                <td className="px-7 py-4">{agent.country}</td>
                                <td className="px-7 py-4">{agent.designation || ""}</td>
                                <td className="px-7 py-4">{agent.createdAt ? moment(agent.createdAt).format("M/D/YYYY") : ""}</td>
                                <td className="px-7 py-4">{agent.isActive ? "Yes" : "No"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default AgentTableEmployees